import React, { Component } from "react";
import addIconUrl from '@deere/ux.brand-foundations/icons/add.svg';
import { Container, Header, Footer, Card, Modal} from '@deere/ux.uxframe-react';
import Button from "../../reusable/components/Button.jsx";
import CompanyInfoLeftHeader from '../../company/components/company-left-header';
import { Link } from 'react-router-dom';
import '../../commodities-services/components/scss/commodity.css';
import SubCommodityComponent from "./sub-commodity-component";
import SuccessMsg from "../../reusable/components/SuccessMessage.jsx";
import ErrorMsg from "../../reusable/components/ErrorMessage.jsx";
import baseurl from '../../api-properties';
import {getAuthToken} from "../../reusable/basic-auth-creds";


class CreateCommodityComponent extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            prosNumber: this.props.match.params.value,
            prosSuppId: 0,
            companyInfo: [],
            commodities: [],
            subCommodities: [],
            saveData: [],
            isCommodityDataExist: false,
            showCommodityComp: false,
            successMsg: "",
            errorMsg: "",
            selectedVal: "",
            selError: "",
            selComCode: ""
        };
    }
    componentDidMount() {
        this.loadSupplierDetails();
    }

    loadSupplierDetails = () => {
        let prosNumber = this.state.prosNumber;
        fetch(baseurl.PROS_SUPPLIER_API_URL + "supllier/getSupplier/" + prosNumber + "/NULL", {
            method: "GET",
            headers: {
                "Authorization": "Basic " + getAuthToken()
            }
        })
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                return response.json();
            })
            .then(data => {
                this.state.isSupplierServiceDown = false;
                this.setState({ companyInfo: data });
                this.setState({ prosSuppId: data.prosSuppId });
                this.loadCommodityDropDownList();
                this.retrieveCommodities();
            }).catch(error => {
                this.state.isSupplierServiceDown = false;
                console.log(error);
            });
    }

    loadCommodityDropDownList = () => {
        let jsonData = { "paramCategory": "COMM_CATEGORY", "orderBy": "PARAM_VALUE" };
        fetch(baseurl.PROS_SUPNET_API_URL + "ps/getParams/", {
            method: "POST",
            body: JSON.stringify(jsonData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": "Basic " + getAuthToken()

            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            return response.json();
        }).then(data => {
            if (data !== undefined && data != null) {
                let commoditieList = data.map(result => { return { value: result.paramCode, display: result.paramValue } })
                this.setState({ commodities: [{ value: '', display: 'Select...' }].concat(commoditieList) });
            }
        }).catch(error => {
            console.log(error);
        });
    }

    retrieveCommodities = () => {
        let prosSuppId = this.state.prosSuppId;
        fetch(baseurl.COMMODITY_API_URL + "commodity/getCommodity/" + prosSuppId, {
            method: "GET",
            headers: {
                "Authorization": "Basic " + getAuthToken()
            }
        })
            .then(response => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                return response.json();
            })
            .then(data => {
                if (data !== undefined && data !== null && data.length > 0)
                    this.setState({ subCommodities: data, isCommodityDataExist: true, showCommodityComp: true });
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleChange = e => {
        this.setState({ selectedVal: e.target.options[e.target.selectedIndex].text, selComCode: e.target.value });
    };

    handleDeleteCommodity = (selComCode) => {
        let prosSuppId = this.state.prosSuppId;
        fetch(baseurl.COMMODITY_API_URL + "/commodity/deleteCommodity/" + prosSuppId + "/" + selComCode, {
            method: "GET",
            headers: {
                "Authorization": "Basic " + getAuthToken()
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            return response;
        }).then(() => {
            this.retrieveCommodities();
        })
    }

    handleFormPrevious = () => {
        if (this.state.isCommodityDataExist === true) {
            this.updateCommodity(true, false);
        } else {
            this.saveCommodity(true, false);
        }
    }

    handleFormContinue = () => {
        if (this.state.isCommodityDataExist === true) {
            this.updateCommodity(false, true);
        } else {
            this.saveCommodity(false, true);
        }
    }

    handleFormSave = () => {
        if (this.state.isCommodityDataExist === true) {
            this.updateCommodity(false, false);
        } else {
            this.saveCommodity(false, false);
        }
    }

    saveCommodity = (isPrevious, isNext) => {
        let prosSuppId = this.state.prosSuppId;
        let userData = this.state.subCommodities;
        fetch(baseurl.COMMODITY_API_URL + "/commodity/insertCommodity/" + prosSuppId, {
            method: "POST",
            body: JSON.stringify(userData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": "Basic " + getAuthToken()
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            if (isPrevious)
                document.location.href = "/diversity-finacial-info/" + this.state.prosNumber;
            else if (isNext)
                document.location.href = "/supplier-summary/" + this.state.prosNumber;
            else {
                this.setState({ successMsg: "Saved Successfully." });
                window.scrollTo(0, 0);
            }
        });
    }

    updateCommodity = (isPrevious, isNext) => {
        let prosSuppId = this.state.prosSuppId;
        let userData = this.state.subCommodities;
        fetch(baseurl.COMMODITY_API_URL + "/commodity/updateCommodity/" + prosSuppId,{
            method: "POST",
            body: JSON.stringify(userData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": "Basic " + getAuthToken()
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            if (isPrevious)
                document.location.href = "/diversity-finacial-info/" + this.state.prosNumber;
            else if (isNext)
                document.location.href = "/supplier-summary/" + this.state.prosNumber;
            else {
                this.setState({ successMsg: "Updated Successfully." });
                window.scrollTo(0, 0);
            }
        });
    }

    handleAddCommodityPopup = e => {
        e.preventDefault();
        this.props.showAddComModal();
    };

    handleAddComClose = e => {
        e.preventDefault();
        this.props.closeAddComModal();
    };

    buildSubCommodities = e => {
        e.preventDefault();
        this.setState({ selError: "" });
        if (this.state.selComCode === undefined || this.state.selComCode === null || this.state.selComCode <= 0) {
            this.setState({ selError: "Please select a Commodity." });
        } else {
            let isValid = false;
            let existSubCommodities = this.state.subCommodities;
            existSubCommodities.map((subCommodityObj) => {
                if (this.state.selComCode === subCommodityObj.code) {
                    isValid = true;
                }
            })
            if (isValid) {
                this.setState({ selError: "Commodity is already exist, please select another Commodity." });
            } else {
                this.loadSubCommodities();
            }
        }
    };

    loadSubCommodities = () => {
        fetch(baseurl.COMMODITY_API_URL + "/commodity/getcategoryByIdForSubComm/commCd/categoryCd/localecd?categoryId=" + this.state.selComCode + "&localeCd=en-US", {
            method: "GET",
            headers: {
                "Authorization": "Basic " + getAuthToken()
            }
        })
            .then(response => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                return response.json();
            })
            .then(subCommodities => {
                let c = [...this.state.subCommodities, subCommodities];
                this.setState({ subCommodities: c, showCommodityComp: true, saveData: c });
            })
            .catch(error => {
                console.log(error);
            });
        this.props.closeAddComModal();
    };

    upDateSaveCard(value) {
        this.state.subCommodities.map((re) => {
            re.itemList.map(item => {
                if (value === item.paramCode) {
                    (item.selected === true) ? item.selected = false : item.selected = true;
                    if (item.selected) {
                        item.insert = true;
                        item.deleted = false;
                    } else {
                        item.insert = false;
                        item.deleted = true;
                    }
                }
            })
        })
    }

    render() {
        return (
            <div>
                <Header pageHeading="Prospective Supplier" />
                <div className="container-fluid bg-light">
                    <Container className="bg-light">
                        <br />
                        <div className="row">
                            <span className="col-sm-24">
                                <h2>John Deere Prospective Supplier Application Form</h2>
                            </span>
                        </div>
                        <div className="row">
                            <span className="col-sm-8">
                                <CompanyInfoLeftHeader companyInfoObj={this.state.companyInfo} />
                            </span>
                            <span className="col-sm-16">
                                {this.state.successMsg !== '' || this.state.errorMsg !== '' ?
                                    <div className="row">
                                        <div className="col-sm-24">
                                            <SuccessMsg message={this.state.successMsg} />
                                            <ErrorMsg message={this.state.errorMsg} />
                                        </div>
                                    </div>
                                    : ""
                                }
                                {this.state.showCommodityComp ? (
                                    <div className="row">
                                        <div className="col-sm-24">
                                            <h3 className="component-section-title">Commodities and Services</h3>
                                        </div>
                                        {this.state.subCommodities.map((item) => (
                                            <div className="col-sm-12">
                                                <SubCommodityComponent
                                                    itemslist={item}
                                                    deleteClick={this.handleDeleteCommodity.bind(this)}
                                                    checkCards={this.upDateSaveCard.bind(this)}
                                                />&nbsp; </div>
                                        ))}
                                        <div className="col-sm-12">
                                            <Link to="/commodity">
                                                <Card onClick={this.handleAddCommodityPopup}>
                                                    <img src={addIconUrl} alt="" style={{ alignSelf: "center", height: 260, width: 350 }} />
                                                    <label style={{ alignSelf: "center" }}>Add Commodity Group</label>
                                                </Card>
                                            </Link>
                                        </div>
                                    </div>
                                ) : (
                                        <div className="col-sm-12">
                                            <h3 className="component-section-title">Commodities and Services</h3>
                                            <Link to={"#"}>
                                                <Card onClick={this.handleAddCommodityPopup}>
                                                    <img src={addIconUrl} alt="" style={{ alignSelf: "center", height: 260, width: 350 }} />
                                                    <label style={{ alignSelf: "center" }}>Add Commodity Group</label>
                                                </Card>
                                            </Link>
                                        </div>
                                    )}
                                <br/>
                                <div className="row">
                                    <div className="col-sm-24" style={{ textAlign: "right" }}>
                                        <Button action={this.handleFormPrevious} type={"secondary"} title={"Previous"} />{" "}
                                        <Button action={this.handleFormSave} type={"secondary"} title={"Save"} />{" "}
                                        <Button action={this.handleFormContinue} type={"warning"} title={"Continue"} />{" "}
                                    </div>
                                </div>
                                <br/>
                            </span>
                        </div>
                    </Container>
                </div>
                <Footer />
                <Modal show={this.props.comModVal} className="modal-footer">
                    <Modal.Header>
                        <h5 className="modal-title">Add Commodity and Services</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="uxf-alert-title">
                            Commodity Group
                            <select className="form-control" onChange={this.handleChange}>
                                {this.state.commodities.map((team) => <option key={team.value} value={team.value} name={team.display}>{team.display}</option>)}
                            </select>
                            <span className="error">{this.state.selError}</span>
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="secondary" action={this.handleAddComClose} title={"Cancel"}/>&nbsp;&nbsp;
                        <Button type="warning" action={this.buildSubCommodities} title={"Add"}/>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}
export default CreateCommodityComponent;